import { render, staticRenderFns } from "./ExistingDocumentEditor.vue?vue&type=template&id=2b036b28&scoped=true&"
import script from "./ExistingDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./ExistingDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExistingDocumentEditor.vue?vue&type=style&index=0&id=2b036b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b036b28",
  null
  
)

export default component.exports